export const initialState = {
  screeningQuestionnaires: [],
  screeningQuestionnaire: {},
  publishQuestionnaires: []
};
